import React from 'react';
import LegalDoc from './LegalDoc';
import content from './ACCESSIBILITY.md?raw';

const Accessibility = () => <LegalDoc content={content} />;

export default Accessibility;
